import { TOAST_TYPE } from '../constants/NotificationConstants';

export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const REMOVE_ALL_TOASTS = 'REMOVE_ALL_TOASTS';

export const addToast = (toastConfig) => ({
  type: ADD_TOAST,
  payload: { toastConfig },
});

export const removeToast = (toastId) => ({
  type: REMOVE_TOAST,
  payload: { toastId },
});

export const removeAllToasts = () => ({
  type: REMOVE_ALL_TOASTS,
});

export const addAIGeneratedContentToast = () =>
  addToast({
    message: 'This response contains AI generated content. Please review for accuracy.',
    autoHideDuration: 5000,
    type: TOAST_TYPE.AI,
  });
